import React from "react";
import "./Invoice.css";

const InvoiceQuotation = ({ invoiceData, onEdit, onPrint, onSave }) => {
    const subTotal = invoiceData.items.reduce(
        (sum, item) => sum + item.quantity * item.amount,
        0
    );
    const grandTotal =
        subTotal +
        subTotal * (invoiceData.igst + invoiceData.cgst + invoiceData.sgst);

    const formatDate = (inputDate) => {
        if (!inputDate) return "";
        const [year, month, day] = inputDate.split("-");
        return `${day}-${month}-${year}`;
    };

    return (
        <div className="container" id="print-section">
            <h1 className="title">Invoice</h1>

            <div className="header">
                <div className="company-info">
                    <strong>VENDOR:</strong>
                    <br />
                    {invoiceData.company?.name}
                    <br />
                    {invoiceData.company?.address}
                    <br />
                    {invoiceData.company?.city}, {invoiceData.company?.state} -{" "}
                    {invoiceData.company?.zip}
                    <br />
                    Phone: {invoiceData.company?.phone}
                    <br />
                    Email: {invoiceData.company?.email}
                </div>
                <div className="invoice-details">
                    {/* <p> */}
                        <strong>Invoice No:</strong> {invoiceData.invoiceNo}
                        <br />
                        <strong>Date:</strong> {formatDate(invoiceData.invoiceDate)}
                    {/* </p> */}
                </div>
                <div className="customer-info">
                    <strong>Customer:</strong>
                    <br />
                    {invoiceData.customer?.name}
                    <br />
                    Email: {invoiceData.customer?.email}
                    <br />
                    Phone: {invoiceData.customer?.phone}
                    <br />
                    <br />

                </div>
            </div>

            <div className="header">
                <div className="customer-info">
                    <strong>BILL TO:</strong>
                    <br />
                    {invoiceData.customer?.BillingAddress?.address_1}
                    <br />
                    {invoiceData.customer?.BillingAddress?.city}
                    <br />
                    {invoiceData.customer?.BillingAddress?.state}
                    <br />
                    {invoiceData.customer?.BillingAddress?.pincode}
                    <br />
                    <br />

                </div>
                <div className="customer-info">
                    <strong>SHIP TO:</strong>
                    <br />
                    {invoiceData.customer?.ShippingAddress?.address_1}
                    <br />
                    {invoiceData.customer?.ShippingAddress?.city}
                    <br />
                    {invoiceData.customer?.ShippingAddress?.state}
                    <br />
                    {invoiceData.customer?.ShippingAddress?.pincode}
                </div>
            </div>
                <strong>Invoice Status:</strong>{invoiceData.inv_status}

            <div>

            </div>

            <table className="table">
                <thead>
                    <tr>
                        <th className="th">Product ID</th>
                        <th className="th">Description</th>
                        <th className="th">Quantity</th>
                        <th className="th">Unit Rate (INR)</th>
                        <th className="th">Total (INR)</th>
                    </tr>
                </thead>
                <tbody>
                    {(invoiceData?.items || []).map((item, i) => (
                        <tr key={i}>
                            <td className="td">{item.code}</td>
                            <td className="td" style={{ padding: 0 }}>
                                <div
                                    className="input-table"
                                    style={{
                                        whiteSpace: "pre-wrap",
                                        wordWrap: "break-word",
                                        padding: 8,
                                        minHeight: 34,
                                    }}
                                >
                                    {item.description}
                                </div>
                            </td>
                            <td className="td">{item.quantity}</td>
                            <td className="td">
                                {item?.amount?.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })}
                            </td>
                            <td className="td">
                                {(item.quantity * item.amount).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="totals">
                Sub Total: ₹{subTotal.toFixed(2)}
                <br />
                {invoiceData.igst > 0 ? (
                    <div>
                        IGST ({(invoiceData.igst * 100).toFixed(2)}%): ₹
                        {(subTotal * invoiceData.igst).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}
                    </div>
                ) : (
                    <>
                        <div>
                            CGST ({(invoiceData.cgst * 100).toFixed(2)}%): ₹
                            {(subTotal * invoiceData.cgst).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}
                        </div>
                        <div>
                            SGST ({(invoiceData.sgst * 100).toFixed(2)}%): ₹
                            {(subTotal * invoiceData.sgst).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}
                        </div>
                    </>
                )}
                Grand Total: ₹{grandTotal.toFixed(2)}
            </div>

            <div style={{ marginTop: 30, textAlign: "center" }} className="no-print">
                <button onClick={onSave} className="save-button">
                    {invoiceData?.id ? "Update" : "Save"}
                </button>{" "}
                <button onClick={onEdit} className="edit-button">
                    Edit
                </button>{" "}
                <button onClick={onPrint} className="print-button">
                    Print
                </button>
            </div>
        </div>
    );
};

export default InvoiceQuotation;
